// extracted by mini-css-extract-plugin
module.exports = {"SectionContainer":"SectionContainer_SectionContainer__fvVvT","isLastSection":"SectionContainer_isLastSection__qoN6O","moveDown1Pixel":"SectionContainer_moveDown1Pixel__lujfd"};